import {createFeatureSelector, createSelector} from "@ngrx/store";
import * as fromAuth from '../reducers/auth.reducer';
import * as dayjs from "dayjs";
import {UserRoles} from "../../shared/enum/user-roles.enum";

export const selectAuthState = createFeatureSelector<fromAuth.State>(fromAuth.authFeatureKey);

export const isLoggedIn = createSelector(selectAuthState, auth => auth.token && dayjs(auth.token.expirationDate).isAfter(dayjs()));

export const canNavigate = createSelector(selectAuthState,
  auth =>
  {
    console.log(`auth.token = ${auth.token?.expirationDate}`)
    console.log(`auth.token = ${auth.token?.jwt}`)
    return (
        auth.token &&
        auth.refreshToken?.jwt && dayjs(auth.refreshToken.expirationDate).isAfter(dayjs())
    );
  }
);

export const getToken = createSelector(selectAuthState, auth => (auth.token ? auth.token.jwt : ''));


export const getUser = createSelector(
  selectAuthState,
  auth => auth.user ? auth.user : ''
);

export const getRoles = createSelector(selectAuthState, auth => (auth.user ? auth.user.roles : []));


export const getFullState = createSelector(
  selectAuthState,
  auth => auth ? auth : ''
);

export const getErrorMessage = createSelector(selectAuthState, auth => auth.error);
